import {isEmpty} from "lodash"
import React from "react"
import {Route, Redirect} from "react-router-dom"
import {LOGIN_RETURN_QUERY_KEY, SlugHelper} from "SlugHelper"

export function PrivateRoutes({isLoggedIn, user, children, ...rest}) {
    if (!isLoggedIn || isEmpty(user)) {
        return (
            <Route
                render={({location}) => {
                    const returnTo = location.pathname + location.search
                    const loginUrl = SlugHelper.getLoginUrl(
                        returnTo.length > 2 ? {[LOGIN_RETURN_QUERY_KEY]: returnTo} : {}
                    )
                    const [pathname, search] = loginUrl.split("?")
                    return (
                        <Redirect
                            to={{
                                pathname,
                                search: search ? `?${search}` : undefined,
                                state: {from: location}
                            }}
                        />
                    )
                }}
            />
        )
    }
    return <Route {...rest} render={() => children} />
}
